import { ClientPod } from '../generated/graphql';
import { RequiredFieldOption } from '../store/clientConfigSlice';
import { useAppSelector } from '../store/store';

export interface ClientRequiredFieldsAndPod {
  clientRequiredFields: RequiredFieldOption[];
  clientPod: ClientPod | undefined;
}

/**
 * Hook to get both the client required fields and client pod for the current client
 * Returns the data fetched from the backend via the unified clientRequiredFields query
 */
export function useClientRequiredFieldsAndPod(): ClientRequiredFieldsAndPod {
  const clientConfig = useAppSelector((state) => state.clientConfig);

  return {
    clientRequiredFields: clientConfig.requiredFields,
    clientPod: clientConfig.pod,
  };
}
